module.exports = __webpack_public_path__ + "img/Blog-Image@3x.19c55d8a.png";